import { AssumptionFormat, ExcelValue } from "@/types/excel/types";

export function coerceNumber(value: ExcelValue): number | null {
  if (value == null) return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value === "boolean") return value ? 1 : 0;
  if (value instanceof Date) return value.getTime();
  if (typeof value === "string") {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }
  return null;
}

export function excelToUiNumber(
  value: ExcelValue,
  format: AssumptionFormat,
): number | null {
  const n = coerceNumber(value);
  if (n == null) return null;
  if (format === "percent") return n * 100;
  return n;
}

export function uiToExcelNumber(
  value: number,
  format: AssumptionFormat,
): number {
  if (format === "percent") return value / 100;
  return value;
}

export function formatUi(value: ExcelValue, format: AssumptionFormat): string {
  const n = coerceNumber(value);
  if (n == null) return value == null ? "—" : String(value);

  switch (format) {
    case "percent":
      return `${(n * 100).toFixed(2)}%`;
    case "currency":
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
      }).format(n);
    default:
      return new Intl.NumberFormat(undefined, {
        maximumFractionDigits: 4,
      }).format(n);
  }
}
